// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1622562062115
      var cssReload = require("/Users/jacobdasilva/_FRONT/Master/wp/alcis-neuro/app/public/assets/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  